module.exports = {
  localeName: 'de-CH',
  momentFormat: 'DD.MM.YYYY'
};
